/*globals require, module, $, TCApi */
var Block = require('../libs/block');

module.exports = Block.extend({
    template: '#receive-list',

    init: function () {
    $('.datepicker').datepicker({format: 'dd.mm.yyyy', language: 'fi', autoclose: true });
        this.hooks.receiveButton = $('#receive');
        this.hooks.receiveButton.click(this.receiveShipment.bind(this));
    },

    receiveShipment: function (e) {
        e.preventDefault();
        var icon = this.hooks.receiveButton.find('i'),
            origClass = icon.attr('class');
        this.hooks.receiveButton.addClass('disabled');
        icon.removeClass().addClass('fa fa-spinner fa-spin m-r-sm');
        TCApi.call('receive_shipment', { pk: $('#receive-list').data('shipment-pk'), date: $("#id-date").val() }).then(function (s) {
            alert(s)
        }.bind(this), function (e) {
            console.error(e);
            // TODO Report error
        }.bind(this)).always(function () {
            icon.removeClass().addClass(origClass);
        }.bind(this));
    },

});
